import React, { PropsWithChildren, useEffect } from 'react';

import { TableHead, TableRow, useTable } from 'components/table';

import { TableProps } from './types';
import { TableWrapper, Table, TableTbody } from './styles';
import { Box, Flex, Typography } from 'components';

function TableTag<ObjectType>({
  objects,
  properties,
  selectRowKey,
  hideCheckbox = false,
  fixedTop,
}: PropsWithChildren<TableProps<ObjectType>>) {
  const { selectedRows, checkSelectedRow, setTriggerSelectMultipleRows, selectMultipleRows } =
    useTable();

  const handleTriggerSelectMultipleRows = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.currentTarget;

    if (checked) {
      selectMultipleRows(objects.map((object) => `${object[selectRowKey as keyof ObjectType]}`));
    } else {
      selectMultipleRows([]);
    }
  };

  useEffect(() => {
    setTriggerSelectMultipleRows(
      selectedRows.length ? selectedRows.length === objects?.length : false
    );
  }, [selectedRows]);

  return objects?.length ? (
    <TableWrapper id="melver-table-wrapper">
      <Table id="melver-table">
        <TableHead
          properties={properties}
          handleTriggerSelectMultipleRows={handleTriggerSelectMultipleRows}
          hideCheckbox={hideCheckbox}
          fixedTop={fixedTop}
        />

        <TableTbody>
          {objects.map((object, index) => {
            return (
              <TableRow
                key={`table-row-${String(object[selectRowKey])}`}
                object={object}
                properties={properties}
                selectRowKey={selectRowKey}
                selected={checkSelectedRow(String(object[selectRowKey]))}
                hideCheckbox={hideCheckbox}
              />
            );
          })}
        </TableTbody>
      </Table>
    </TableWrapper>
  ) : (
    <Flex py={4} flexGrow={0.8} alignItems="center" justifyContent="center">
      <Box textAlign="center">
        <img src="/images/no-results.png" width="230" height="165" alt="" />
        <Typography type="type1" upper color="black30" mt={3}>
          Nenhum registro encontrado
        </Typography>
      </Box>
    </Flex>
  );
}

export default TableTag;
